import { useState, useEffect } from "react";
import {Link, useNavigate } from "react-router-dom";
import { StyledAuth, ContentWrapper, TextBlock, OrangeLine } from "./style";
import { MyText } from "../../components";
import { Col, Row} from "antd";
import { LogoIcon } from "../../assets";
import { LANG_KEY } from "../../utils/constants/language";
import { MySegmented } from "../../components";
import { ROUTE_PATH, selectStore } from "../../utils/"
import { useTranslation } from "react-i18next";
import { useEmbeddedLink } from "../../utils/context/embed";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { useSelector } from "react-redux";
export const RestoreConfirm = () => {
  const {t} = useTranslation("common")
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [isExiting, setIsExiting] = useState(false);
  const embeddedLink = useEmbeddedLink();
  const {profile: {restoreData: restoreDataState}} = useSelector(selectStore)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        embeddedNavigate('/auth/restore/recovery');
      }, 300);
    }, 2000);

    return () => clearTimeout(timer);
  }, [embeddedNavigate]);

  return (
    <StyledAuth className={isExiting ? 'fade-out' : 'fade-in'}>
      <div style={{ position: 'absolute', top: 40, right: 40 }}>
        <MySegmented
          options={[
            { label: 'ҚАЗ', value: LANG_KEY.KZ },
            { label: 'РУС', value: LANG_KEY.RU },
          ]}
        />
      </div>

      <ContentWrapper>
        <Row justify="center" gutter={[16, 16]}>
          <Col style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Link to={embeddedLink(ROUTE_PATH.MAIN)}>

            <LogoIcon
              style={{
                position: 'fixed',
                top: '160px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '260px',
                height: '60px',
              }}
            />
            </Link>
          </Col>
          <Col span={24} style={{ marginTop: 145 }}>
            <TextBlock>
              <OrangeLine />
              <MyText color="#0A033C" size={20} lineHeight="32px">
              {/* {t('passwordRecoverySent')} */}
              {restoreDataState?.message}
              </MyText>
            </TextBlock>
          </Col>
        </Row>
      </ContentWrapper>
    </StyledAuth>
  );
};
